import NoData from '@/components/common/no-data/NoData';
import FormChooseServiceVEP from '@/components/forms/form-choose-service/FormChooseServiceVEP';
import FormChooseService from '@/components/forms/form-choose-service/FormChooseService';
import { Skeleton } from '@/components/ui/skeleton';
import useGetOrgCategoriesWIthServices from '@/hooks/queries/services-api/useGetOrgCategoriesWithServices';
import useGetServicesEnabled from '@/hooks/queries/services-api/useGetServicesEnabled';
import { VEPCodes } from '@/lib/utils';
import type { TOrganizationFAQ } from '@/services/organization';
import type React from 'react';

const ChooseServiceStep: React.FC<{ organization: TOrganizationFAQ }> = ({
  organization
}) => {
  const { data, isPending } = useGetServicesEnabled();
  const {
    data: categoriesWithServices,
    isPending: isPendingCategoriesWithServices
  } = useGetOrgCategoriesWIthServices(organization.id);

  if (isPending || isPendingCategoriesWithServices) {
    return (
      <>
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-10 mt-8" />
        <Skeleton className="w-full h-10 mt-8" />
        <Skeleton className="w-full h-10 mt-8" />
      </>
    );
  }

  if (!data || !categoriesWithServices) return <NoData />;

  return (
    <>
      {VEPCodes.includes(organization.code) ? (
        <FormChooseServiceVEP services={categoriesWithServices} />
      ) : (
        <FormChooseService
          services={categoriesWithServices}
          organization={organization}
        />
      )}
    </>
  );
};

export default ChooseServiceStep;
